import {useState} from "react";


const OverviewReportConfigurator = (props) => {

    const showDetailCard = props.showDetailCard;
    const setShowDetailCard = props.setShowDetailCard;
    const showGraphicalChart = props.showGraphicalChart;
    const setShowGraphicalChart = props.setShowGraphicalChart;
    const showCollectiveScores = props.showCollectiveScores;
    const setShowCollectiveScores = props.setShowCollectiveScores;
    const showGraphicalData = props.showGraphicalData;
    const setShowGraphicalData = props.setShowGraphicalData;
    const showTabularData = props.showTabularData;
    const setShowTabularData = props.setShowTabularData;
    const showCoachingProgramme = props.showCoachingProgramme;
    const setShowCoachingProgramme = props.setShowCoachingProgramme;
    const showCoachingExercises = props.showCoachingExercises;
    const setShowCoachingExercises = props.setShowCoachingExercises;
    const showPillarTables = props.showPillarTables;
    const setShowPillarTables = props.setShowPillarTables;
    const subscription = props.subscription;
    const canIncludePillarTables = subscription !== null && subscription >= 1;

    const [reportName, setReportName] = useState("");
    const [coverPages, setCoverPages] = useState(true);
    const [introduction, setIntroduction] = useState(true);
    const [debrief, setDebrief] = useState(true);
    const [backPage, setBackPage] = useState(true);

    const [showDetailedScoreData, setShowDetailedScoreData] = useState(
        showGraphicalData && showTabularData);
    const [showResultsAndRecommendations, setShowResultsAndRecommendations] = useState(
        showCoachingProgramme && showCoachingExercises
    );

    const handleSlider = (ev) => {
        if (!ev) return;
        const id = ev.currentTarget.id;

        switch (id) {
            case '1': setCoverPages(!coverPages); break;
            case '2': setIntroduction(!introduction); break;
            case '3': setDebrief(!debrief); break;
            case '4': setShowDetailCard(!showDetailCard); break;
            case '5': setShowGraphicalChart(!showGraphicalChart); break;
            case '6': setShowCollectiveScores(!showCollectiveScores); break;

            case '7': {
                const newVal = !showDetailedScoreData;
                setShowDetailedScoreData(newVal);
                setShowGraphicalData(newVal);
                setShowTabularData(newVal);
                break;
            }

            case '8': {
                const newVal = !showResultsAndRecommendations;
                setShowResultsAndRecommendations(newVal);
                setShowCoachingProgramme(newVal);
                setShowCoachingExercises(newVal);
                break;
            }

            case '9':
                if (!canIncludePillarTables) break;
                setShowPillarTables(!showPillarTables);
                break;
            case '10': setBackPage(!backPage); break;
            default: break;
        }
    };


    const handleSubmit = () => {
        // Added to correctly set up appendix section structure in the backend
        const sectionList = [];

        if (coverPages) sectionList.push("Report Title Page");
        if (introduction) sectionList.push("Introduction to PERILL");
        if (debrief) sectionList.push("Interpreting & Debriefing Guidance");
        if (showDetailCard) sectionList.push("Survey Overview Card");
        if (showGraphicalChart) sectionList.push("PERILL Results Wheel");
        if (showCollectiveScores) sectionList.push("Score Overview");
        if (showGraphicalData || showTabularData) sectionList.push("Detailed Score Data");
        if (showCoachingProgramme || showCoachingExercises) sectionList.push("Results & Recommendations");
        if (canIncludePillarTables && showPillarTables) sectionList.push("Scores by Questions");
        if (backPage) sectionList.push("Report Back Page");

        let body = {
            "name": reportName,
            "cover_pages": coverPages,
            "introduction": introduction,
            "debrief": debrief,
            "pillars": false,
            "next_steps": false,
            "back_page": backPage,
            "sectionList": sectionList
        }
        props.saveConfig(body);
        props.generate();
    }

    return (
        <>
            <div className="page-mask" onClick={props.close}/>
            <div className="report-configure-page overview">
                <div className="report-configure-header">
                    <div className="report-configure-title col">Report Configurator</div>
                </div>
                <div className="report-configure-description-container">
                    <div className="report-configure-description">
                        This configuration tool enables you to include or exclude components rendered into the PDF for
                        you to share with your clients and their teams.
                    </div>
                    <div className="report-configure-description">
                        You report will be generated server side and available in the Reports page for you to open
                        or download.
                    </div>
                </div>
                <div className="field-input">
                    <div className="label">Report Name</div>
                    <div className="field-input-entry">
                        <input className="report-input" name="report-name" type="text" value={reportName}
                               onChange={ev => setReportName(ev.target.value)} required
                        />
                    </div>
                </div>
                <div className="report-configure-options-container">
                    <div className="report-configure-options-row">
                        <div className="report-configure-option-title">Report Title Page</div>
                        <div className="report-configure-option-slider-container">
                            <div className="slider">
                                <div className={coverPages ? "slider-container on" : "slider-container off"}
                                     id="1" onClick={handleSlider}>
                                    <div className={coverPages ? "slider-button on" : "slider-button off"}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="report-configure-options-row">
                        <div className="report-configure-option-title">Introduction to PERILL</div>
                        <div className="report-configure-option-slider-container">
                            <div className="slider">
                                <div className={introduction ? "slider-container on" : "slider-container off"}
                                     id="2" onClick={handleSlider}>
                                    <div className={introduction ? "slider-button on" : "slider-button off"}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="report-configure-options-row">
                        <div className="report-configure-option-title">Interpreting & Debriefing Guidance</div>
                        <div className="report-configure-option-slider-container">
                            <div className="slider">
                                <div className={debrief ? "slider-container on" : "slider-container off"}
                                     id="3" onClick={handleSlider}>
                                    <div className={debrief ? "slider-button on" : "slider-button off"}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="report-configure-options-row">
                        <div className="report-configure-option-title">Survey Overview Card</div>
                        <div className="report-configure-option-slider-container">
                            <div className="slider">
                                <div className={showDetailCard ? "slider-container on" : "slider-container off"}
                                     id="4" onClick={handleSlider}>
                                    <div className={showDetailCard ? "slider-button on" : "slider-button off"}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="report-configure-options-row">
                        <div className="report-configure-option-title">PERILL Results Wheel</div>
                        <div className="report-configure-option-slider-container">
                            <div className="slider">
                                <div className={showGraphicalChart ? "slider-container on" : "slider-container off"}
                                     id="5" onClick={handleSlider}>
                                    <div className={showGraphicalChart ? "slider-button on" : "slider-button off"}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="report-configure-options-row">
                        <div className="report-configure-option-title">Diagnostics Results Highlights: Score Overview</div>
                        <div className="report-configure-option-slider-container">
                            <div className="slider">
                                <div className={showCollectiveScores ? "slider-container on" : "slider-container off"}
                                     id="6" onClick={handleSlider}>
                                    <div className={showCollectiveScores ? "slider-button on" : "slider-button off"}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="report-configure-options-row">
                        <div className="report-configure-option-title">Diagnostics Results Highlights: Detailed Score Data</div>
                        <div className="report-configure-option-slider-container">
                            <div className="slider">
                                <div className={showDetailedScoreData ? "slider-container on" : "slider-container off"}
                                     id="7" onClick={handleSlider}>
                                    <div className={showDetailedScoreData ? "slider-button on" : "slider-button off"}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="report-configure-options-row">
                        <div className="report-configure-option-title">
                            Diagnostic Results Highlights: Results & Recommendations
                        </div>
                        <div className="report-configure-option-slider-container">
                            <div className="slider">
                                <div
                                    className={showResultsAndRecommendations ? "slider-container on" : "slider-container off"}
                                    id="8"
                                    onClick={handleSlider}
                                >
                                    <div className={showResultsAndRecommendations ? "slider-button on" : "slider-button off"} />
                                </div>
                            </div>
                        </div>
                    </div>

                    {canIncludePillarTables ? (
                    <div className="report-configure-options-row">
                        <div className="report-configure-option-title">Scores by Questions</div>
                        <div className="report-configure-option-slider-container">
                            <div className="slider">
                                <div className={showPillarTables ? "slider-container on" : "slider-container off"}
                                     id="9" onClick={handleSlider}>
                                    <div className={showPillarTables ? "slider-button on" : "slider-button off"}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    ) : null}
                    <div className="report-configure-options-row">
                        <div className="report-configure-option-title">Report Back Page</div>
                        <div className="report-configure-option-slider-container">
                            <div className="slider">
                                <div className={backPage ? "slider-container on" : "slider-container off"}
                                     id="10" onClick={handleSlider}>
                                    <div className={backPage ? "slider-button on" : "slider-button off"}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="report-configure-submit-container">
                    <div className={`report-configure-submit link ${reportName ? "active" : "disabled"}`}
                         onClick={reportName ? handleSubmit : null}>Generate Report</div>
                </div>
            </div>
        </>
    )
}

export default OverviewReportConfigurator
